import React from 'react';
import Styled from './Styled';
const UserInteraction = ({ enabled, children }) => (React.createElement(Styled.Wrapper, { "$enabled": enabled }, children));
export default UserInteraction;
